import React, { useEffect, useState, useContext } from "react";
import { Link } from "gatsby";
import { useForm } from "react-hook-form";
import { useAudioTranslation } from "hooks/Forms/useAudioTranslation";
import { ExpertField } from "./expertiseField";
import DataProvider from "Context/DataContext";

function SecondStepAccount({ currentStep, setCurrentStep, data }) {
  const { nativeLangData, setNativeLangData } = useContext(DataProvider);
  const { expertiseData, setExpertiseData } = useContext(DataProvider);
  const { originalLangData, setOriginalLangData } = useContext(DataProvider);
  const { targetLangData, setTargetLangData } = useContext(DataProvider);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setCurrentStep(3);
  };

  const handleChange = (event) => {
    setNativeLangData([...nativeLangData, event.target.value]);
  };
  const handleExpertiseChange = (event) => {
    setExpertiseData([...expertiseData, event.target.value]);
  };
  const handleOriginalChange = (event) => {
    setOriginalLangData([...originalLangData, event.target.value]);
  };
  const handleTargetChange = (event) => {
    setTargetLangData([...targetLangData, event.target.value]);
  };

  return (
    <div>
      <div className="rounded-lg bg-black py-5 px-12 h-full mx-4 md:w-10/12 lg:w-9/12 flex flex-col justify-center md:mx-auto max-w-[800px] font-primary text-white relative">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 lg:grid-cols-2 relative">
            <div>
              <p className="text-24">Native Language</p>
              <p className="text-base text-[#4f4f4f] mb-2">
                You can select up to 2 native languages
              </p>
              <select
                className="bg-white font-primary text-xs mb-6 min-h-[106px] text-black w-full lg:w-72 language"
                id="native_language"
                name="native_language"
                {...register("native_language")}
                multiple
                onChange={(e) => handleChange(e)}
                value={nativeLangData?.map((selectedVal) => {
                  return selectedVal;
                })}
              >
                {data
                  ? data?.data?.map(({ source_language }) => (
                      <option
                        value={source_language}
                        style={{
                          background: nativeLangData.includes(source_language)
                            ? "gray"
                            : "",
                        }}
                        className="text-lg text-black"
                      >
                        {source_language}
                      </option>
                    ))
                  : null}
              </select>
            </div>
            <div>
              <p className="text-24">Expertise field</p>
              <p className="text-base text-[#4f4f4f] mb-2">
                You can select up to 3 expertise fields
              </p>
              <select
                className="bg-white font-primary text-lg mb-6 min-h-[106px] text-black w-full lg:w-72"
                multiple
                id="expertise_field"
                name="expertise_field"
                {...register("expertise_field")}
                onChange={(e) => handleExpertiseChange(e)}
                value={expertiseData?.map((expVal) => {
                  return expVal;
                })}
              >
                {ExpertField
                  ? ExpertField.map(({ fieldsName }, index) => (
                      <option
                        value={fieldsName}
                        key={index}
                        style={{
                          background: expertiseData.includes(fieldsName)
                            ? "gray"
                            : "",
                        }}
                        className="text-lg text-black"
                      >
                        {fieldsName}
                      </option>
                    ))
                  : null}
              </select>
            </div>
            <div className="mb-10">
              <p className="text-24">Original Language</p>
              <p className="text-base text-[#4f4f4f] mb-2">
                You can select many language pairs. Just coptionck on "Add"
                after selecting each language pair
              </p>
              <select
                className="bg-white font-primary text-lg mb-6 min-h-[106px] text-black w-full lg:w-72"
                multiple
                id="original_language"
                name="original_language"
                {...register("original_language")}
                onChange={(e) => handleOriginalChange(e)}
                value={originalLangData?.map((selectedVal) => {
                  return selectedVal;
                })}
              >
                <option
                  className="text-[16px] text-black font-opensans"
                  disabled
                  selected
                >
                  Select Language
                </option>

                {data
                  ? data?.data?.map(({ source_language }, index) => (
                      <option
                        key={index}
                        value={source_language}
                        className="text-lg text-black"
                        style={{
                          background: originalLangData.includes(source_language)
                            ? "gray"
                            : "",
                        }}
                      >
                        {source_language}
                      </option>
                    ))
                  : null}
              </select>
            </div>
            {originalLangData.length > 0 || targetLangData ? (
              <div className="mb-10">
                <p className="text-24">Target Language:</p>
                <p className="text-base text-[#4f4f4f] mb-2 invisible">
                  You can select many language pairs. Just coptionck on "Add"
                  after selecting each language pair
                </p>
                <select
                  className="bg-white font-primary text-xs mb-6 min-h-[106px] text-black w-full lg:w-72"
                  id="target_language"
                  name="target_language"
                  {...register("target_language")}
                  multiple
                  onChange={(e) => handleTargetChange(e)}
                  value={targetLangData?.map((orgVal) => {
                    return orgVal;
                  })}
                >
                  {data
                    ? data?.data?.map(({ source_language }) => (
                        <option
                          value={source_language}
                          className="text-lg text-black"
                          style={{
                            background: targetLangData.includes(source_language)
                              ? "gray"
                              : "",
                          }}
                        >
                          {source_language}
                        </option>
                      ))
                    : null}
                </select>
              </div>
            ) : (
              ""
            )}
            <button className="bg-lightBlue text-white max-w-max rounded py-1 px-5 absolute right-0 bottom-0">
              Continue
            </button>
          </div>
          <p className="text-white mt-12 mb-3">
            If you encounter any problems signing up, Please{" "}
            <a
              href="https://www.tomedes.com/contactus.php"
              target="_blank"
              className="text-lightBlue"
            >
              Contact
            </a>
            &nbsp;us or&nbsp;
            <a
              href="https://server.iad.liveperson.net/hc/4900916/?cmd=file%C2%A0file=visitorWantsToChat%C2%A0site=4900916%C2%A0byhref=1%C2%A0imageUrl=https://server.iad.liveperson.net/hcp/Gallery/ChatButton-Gallery/English/General/1a/"
              className="text-lightBlue"
            >
              chat now
            </a>
            &nbsp;with our live agents.
          </p>
        </form>
        <button
          // onClickCapture={handleSubmit(onSubmit)}
          onClick={() => {
            setCurrentStep(1);
          }}
          className="text-white absolute bottom-[-40px] left-0 hover:text-lightBlue "
        >
          Return to first step
        </button>
      </div>
    </div>
  );
}

export default SecondStepAccount;
